import { NovoPwd, AlterarPwd } from '@newspacebpo/mf_nslogin';
import queryString from 'query-string';
import React from 'react';

const AlterarSenhaLogado = () => (
  <AlterarPwd
    redirectBack='#/'
    redirectSuccess='#/'
    bgColorContainer={'rgba(255, 255, 255, .4)'}
    textColorBoxTitle={'#000000'}
    bgColorBoxTitle={'rgba(255, 255, 255, .15)'}
    boxTitle={'Financiamento de Veículos'}
  />
);

const AlterarSenhaHash = ({ hash }) => (
  <div className="customlogin">
    <NovoPwd
      hash={hash}
      redirectBack='#/'
      redirectSuccess='#/login'
      bgColorContainer={'rgba(255, 255, 255, .4)'}
      willCp={false}
      textColorBoxTitle={'#000000'}
      bgColorBoxTitle={'rgba(255, 255, 255, .15)'}
      boxTitle={'Financiamento de Veículos'}
    />
  </div>
);

const AlterarPwdPage = ({ location }) => {
    const { search } = location;
    const { hash } = queryString.parse(search);

    if (!!hash) {
      return <AlterarSenhaHash hash={hash}/>
    }

    return <AlterarSenhaLogado/>;
};

export default AlterarPwdPage;
